export const participationAccessSettings = [
  {
    title: "Unrestricted",
    value: "anyone_as_guest",
    features: [
      {
        icon: "insert_link",
        title:
          "Anyone inside and/or outside your organization can participate",
      },
      {
        icon: "person_outline",
        title: "No email or login required",
      },
      {
        icon: "show_chart",
        title: "Basic Analytics",
      },
    ],
  },
  {
    title: "Restricted",
    value: "tenant_open",
    features: [
      {
        icon: "shield",
        title: "Only people with your company domain name can participate",
      },
      {
        icon: "person",
        title: "Email and login required",
      },
      {
        icon: "multiline_chart",
        title: "Basic & Advanced Analytics",
      },
    ],
  },
  {
    title: "Private",
    value: "invite_only",
    features: [
      {
        icon: "email",
        title:
          "Only specific email addresses you provide can participate",
      },
      {
        icon: "person",
        title: "Email and login required",
      },
      {
        icon: "multiline_chart",
        title: "Basic & Advanced Analytics",
      },
    ],
  },
];

export const participationAnonymitySettings = [
  {
    title: "Anonymous",
    value: "anonymous",
    description: "Ideal if you want authentic, honest responses from participants",
    explanation: "Participation will be fully anonymous for your POPin"
  },
  {
    title: "Named",
    value: "named",
    description: "Ideal if you want participants to publicly recognize one another",
    explanation: "Participant names will be displayed for everyone to see in your POPin"
  },
];